<template>
    <header :class="{'reStyleHeaderContent':$root.sectionIndexHome!=1}" id="headerContent" class="d-flex width90 align-items-center justify-content-between hiddenInMobile">
         <buttons />
         <menuBar v-if="$root.sectionIndexHome==1 || $route.name=='healthAmbassador'"  />  
        <logo v-if="$root.sectionIndexHome==1" />
        <logo v-else  data-aos="flip-left"
      data-aos-duration="2500"

      data-aos-once="false" class="width5"/>
    </header>
</template>
<script>
import Logo from "@/components/front/shared/logo.vue"
import buttons from "@/components/front/home/slider/header/buttonsCalibrationLab.vue"
import menuBar from "@/components/front/home/slider/header/menuCalibrationLab.vue"
export default {
    components:{
        buttons,
        menuBar,
        Logo
    }
}
</script>
<style scoped>
/* #healthAmbassador #headerContent {
  width: 100%;
  padding: 1% 1%;
  position: relative;
  z-index: 10;
} */
</style>